import { render, staticRenderFns } from "./ApprovalApproverField.vue?vue&type=template&id=15f5e4aa"
import script from "./ApprovalApproverField.vue?vue&type=script&lang=js"
export * from "./ApprovalApproverField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports